import { Avatar, AvatarFallback, AvatarImage } from '@crowdfpl/ui-web/avatar';
import { CDN_BASE_URL } from '@/constants';

interface Ambassador {
  name: string;
  handle: string;
  followers: string;
}

const AMBASSADORS: Ambassador[] = [
  { name: 'FPL_Salah', handle: 'FPL_Salah', followers: '144K' },
  { name: 'FPLGOAT7', handle: 'FPLGOAT7', followers: '137K' },
  { name: 'lateriser12', handle: 'lateriser12', followers: '107K' },
  { name: 'FPLOlympian', handle: 'FPLOlympian', followers: '84K' },
  { name: 'Pras_fpl', handle: 'Pras_fpl', followers: '72K' },
  { name: 'ZopharFPL', handle: 'ZopharFPL', followers: '39K' },
  { name: 'FPL_Brandon', handle: 'FPL_Brandon', followers: '29K' },
  { name: 'FPL_Zlatan', handle: 'FPL_Zlatan', followers: '21K' },
  { name: 'TheFPLWire', handle: 'TheFPLWire', followers: '19K' },
  { name: 'BakerFPL343', handle: 'BakerFPL343', followers: '17K' },
];

const getAvatarUrl = (handle: string) =>
  `${CDN_BASE_URL}/ambassadors/x/${handle}.webp`;

function SolioLogo({ className }: { className?: string }) {
  return <img src="/icons/solio-logo.svg" alt="Solio" className={className} />;
}

function FPLCoreLogo({ className }: { className?: string }) {
  return <img src="/icons/fpl_core_logo.svg" alt="FPL Core" className={className} />;
}

export function AmbassadorStrip() {
  return (
    <section className="overflow-visible py-2">
      <h2 className="mb-3 text-center text-lg font-bold text-foreground md:mb-4 md:text-left md:text-xl">
        Leading FPL creators in the Crowd
      </h2>

      <div className="overflow-visible md:hidden">
        <div className="mb-2 flex items-start justify-center gap-8">
          <a
            href="https://fpl.solioanalytics.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex cursor-pointer flex-col items-center gap-1 transition-transform duration-150 hover:scale-[1.02]"
          >
            <SolioLogo className="h-11 w-auto transition-opacity group-hover:opacity-90" />
            <div className="text-center">
              <span className="block text-[11px] font-semibold leading-tight text-foreground group-hover:underline">
                Solio Analytics
              </span>
              <span className="mt-px block text-[9px] leading-snug text-muted-foreground opacity-0 select-none">
                {'\u00A0'}
              </span>
            </div>
          </a>
          <a
            href="https://fplcore.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex cursor-pointer flex-col items-center gap-1 transition-transform duration-150 hover:scale-[1.02]"
          >
            <FPLCoreLogo className="h-11 w-11 rounded-full object-cover transition-opacity group-hover:opacity-90" />
            <div className="text-center">
              <span className="block text-[11px] font-semibold leading-tight text-foreground group-hover:underline">
                FPL Core
              </span>
              <span className="mt-px block text-[9px] leading-snug text-muted-foreground opacity-0 select-none">
                {'\u00A0'}
              </span>
            </div>
          </a>
        </div>
        <div className="mx-auto flex max-w-[300px] flex-wrap justify-center gap-x-1 gap-y-3 overflow-visible">
          {AMBASSADORS.map((ambassador) => (
            <a
              key={ambassador.handle}
              href={`https://x.com/${ambassador.handle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex w-[92px] cursor-pointer flex-col items-center gap-1 transition-transform duration-150 hover:scale-[1.02]"
            >
              <Avatar className="h-11 w-11 bg-muted transition-opacity group-hover:opacity-90">
                <AvatarImage
                  src={getAvatarUrl(ambassador.handle)}
                  alt={ambassador.name}
                />
                <AvatarFallback className="bg-muted" />
              </Avatar>
              <div className="text-center">
                <span className="block text-[11px] font-semibold leading-tight text-foreground group-hover:underline">
                  {ambassador.name}
                </span>
                <span className="mt-px block text-[9px] leading-snug text-muted-foreground">
                  {ambassador.followers}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>

      <div className="hidden md:flex md:justify-center">
        <div className="max-w-full overflow-x-auto overflow-y-visible scrollbar-hide py-3">
          <div className="flex w-fit items-center gap-6 lg:gap-8">
            <a
              href="https://fpl.solioanalytics.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-shrink-0 cursor-pointer flex-col items-center gap-1.5 transition-transform duration-150 hover:scale-[1.04]"
            >
              <SolioLogo className="h-10 w-auto transition-opacity group-hover:opacity-90" />
              <div className="text-center">
                <span className="block whitespace-nowrap text-[11px] font-semibold leading-tight text-foreground group-hover:underline">
                  Solio Analytics
                </span>
                <span className="mt-0.5 block text-[10px] leading-snug text-muted-foreground opacity-0 select-none">
                  {'\u00A0'}
                </span>
              </div>
            </a>
            <a
              href="https://fplcore.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-shrink-0 cursor-pointer flex-col items-center gap-1.5 transition-transform duration-150 hover:scale-[1.04]"
            >
              <FPLCoreLogo className="h-10 w-10 rounded-full object-cover transition-opacity group-hover:opacity-90" />
              <div className="text-center">
                <span className="block whitespace-nowrap text-[11px] font-semibold leading-tight text-foreground group-hover:underline">
                  FPL Core
                </span>
                <span className="mt-0.5 block text-[10px] leading-snug text-muted-foreground opacity-0 select-none">
                  {'\u00A0'}
                </span>
              </div>
            </a>
            {AMBASSADORS.map((ambassador) => (
              <a
                key={ambassador.handle}
                href={`https://x.com/${ambassador.handle}`}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-shrink-0 cursor-pointer flex-col items-center gap-1.5 transition-transform duration-150 hover:scale-[1.04]"
              >
                <Avatar className="h-10 w-10 bg-muted transition-opacity group-hover:opacity-90">
                  <AvatarImage
                    src={getAvatarUrl(ambassador.handle)}
                    alt={ambassador.name}
                  />
                  <AvatarFallback className="bg-muted" />
                </Avatar>
                <div className="text-center">
                  <span className="block whitespace-nowrap text-[11px] font-semibold leading-tight text-foreground group-hover:underline">
                    {ambassador.name}
                  </span>
                  <span className="mt-0.5 block text-[10px] leading-snug text-muted-foreground">
                    {ambassador.followers}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
